import React from "react";


const PrivacyPolicy = () => {
  return (
    <div className="pp-container">
      <div className="pp-card">
        <div className="pp-header">
          <h2 className="pp-title"> Privacy Policy</h2>
        </div>

        <div className="pp-body">
          <p className="pp-updated">Last Updated: April 24, 2025</p>

          <h4 className="pp-section-title">CryptoApp Privacy Policy</h4>
          <p className="pp-text">
            At <strong>CryptoApp Inc.</strong> ("we", "us", or "our"), we are committed 
            to protecting your privacy. This Privacy Policy explains how we 
            collect, use, disclose, and safeguard your information when you 
            use our cryptocurrency trading platform ("Service").
          </p>

          <h4 className="pp-section-title">1. Information We Collect</h4>
          <ul className="pp-list">
            <li>
              <strong>Personal Information:</strong> Name, email, phone number,
              government-issued ID for verification.
            </li>
            <li>
              <strong>Transaction Data:</strong> Crypto trades, wallet addresses,
              payment/banking details.
            </li>
            <li>
              <strong>Usage Data:</strong> IP address, browser, device info, cookies.
            </li>
          </ul>

          <h4 className="pp-section-title">2. How We Use Your Information</h4>
          <ul className="pp-list">
            <li>To operate and maintain the Service.</li>
            <li>To verify your identity and process transactions.</li>
            <li>To improve performance and user experience.</li>
            <li>To comply with legal obligations and prevent fraud.</li>
          </ul>

          <h4 className="pp-section-title">3. How We Share Your Information</h4>
          <ul className="pp-list">
            <li>With payment/KYC/security service providers.</li>
            <li>With legal authorities when required.</li>
            <li>During mergers or business transfers.</li>
          </ul>

          <h4 className="pp-section-title">4. Data Security</h4>
          <p className="pp-text">
            We use encryption, secure servers, and strict controls to protect your 
            data. However, no method is entirely secure, and complete safety 
            cannot be guaranteed.
          </p>

          <h4 className="pp-section-title">5. Your Rights</h4>
          <ul className="pp-list">
            <li>Access your stored personal data.</li>
            <li>Request corrections or updates.</li>
            <li>Request deletion (subject to law).</li>
            <li>Withdraw consent for non-essential data usage.</li>
          </ul>

          <p className="pp-text">
            For any privacy requests, contact:<br />
            <strong>Email:</strong> support@cryptoapp.com
          </p>

          <h4 className="pp-section-title">6. Policy Changes</h4>
          <p className="pp-text">
            We may update this Privacy Policy periodically. Updated versions will 
            be posted with a revised date.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
